<template>
  <div class="list-view">
    <div id="g-contents">
      <div class="list-sub-menu" v-if="subType === 'general_list'">
        <div class="title">
          <h2 v-html="title"></h2>
        </div>
        <div class="filter-wrap" v-if="!isLoading">
          <FilterList :filter="filter"/>
        </div>
      </div>
      <editor-pick-header v-if="subType === 'editor_pick_list'" :title-list="titleList" :top-button-list="topButtonList"/>
      <template v-if="hasCellList">
        <div class="list-view-detail">
          <component
            v-for="(cell, index) in cellList"
            :key="'list_cell_' + index"
            :is="thumbnailInfo.componentName"
            :cell-info="cell"
            :cell-type="cellType"
            :thumbnail-info="thumbnailInfo"></component>
        </div>
          <paging-component
            v-if="!isLoading"
            :is-loading="isLoading"
            :page-count="pageCount"
            :limit="limit"
            :paging-count="10"
            :current-page="currentPage"
          ></paging-component>
      </template>
      <template v-else-if="!hasCellList && !isLoading">
       <EmptyList></EmptyList>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { apiRequest, applyQueryString } from '@/common/utils/request.common'
import { parseUrl } from 'query-string'
import { HTTP_METHOD_GET } from '@/common/utils/request.const'
import FilterList from '@/pages/list/FilterList'
import { getCheckAdult, getThumbnailInfo, doActionAdultVerification, setDisableScrolling } from '@/common/utils/common'
import ListViewMixin from '@/mixins/listview.mixin'
import CircleCell from '@/components/model/cell/CircleCell'
import LandscapeCell from '@/components/model/cell/LandscapeCell'
import PortraitCell from '@/components/model/cell/PortraitCell'
import PagingComponent from '@/components/common/PagingComponent'
import EmptyList from '@/pages/list/EmptyList'
import EditorPickHeader from '@/pages/list/EditorPickHeader'
import cookie from '@/common/utils/cookie'
import { mapMutations } from 'vuex'
import { SET_CURRENT_MENU } from '@/common/resources/const'
import { getReferer } from '@/common/utils/referer'
export default {
  name: 'ListView',
  components: {
    FilterList,
    CircleCell,
    LandscapeCell,
    PortraitCell,
    PagingComponent,
    EmptyList,
    EditorPickHeader
  },
  mixins: [ListViewMixin],
  data () {
    return {
      isLoading: true,
      thumbnailInfo: null,
      uiCode: null,
      url: null,
      query: null,
      currentPage: 1,
      pageCount: 0,
      limit: 20,
      pagingCount: 10,
      titleList: [],
      subType: '',
      topButtonList: [],
      settings: cookie.getAdultSettings()
    }
  },
  computed: {
    hasCellList () {
      return this.cellList.length > 0
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU]),
    setData () {
      this.isLoading = true
      const CELL_TYPE_PATH = ['cell_toplist', 'cell_type']
      const setPageCount = data => { this.pageCount = Number(_.get(data, ['cell_toplist', 'pagecount'], '0')); return data }
      const setTitleList = data => { this.titleList = _.get(data, ['cell_toplist', 'title_list'], []); return data }
      const setSubTitle = data => { this.subType = _.get(data, 'sub_type', ''); return data }
      const setTopButtonList = data => { this.topButtonList = _.get(data, ['cell_toplist', 'topbuttonlist'], []); return data }
      const setThumbnailInfo = data => { this.thumbnailInfo = getThumbnailInfo(_.get(data, CELL_TYPE_PATH, '')); return data }
      const scrollToTop = () => { window.scrollTo(0, 0) }
      const loadComplete = () => { this.isLoading = false }
      const assignedQuery = Object.assign({}, this.query)
      delete assignedQuery.api
      const req = { url: applyQueryString(`https://${this.url}`, assignedQuery), method: HTTP_METHOD_GET }
      apiRequest(req)
        .then(this.getData)
        .then(this.setTitle)
        .then(this.setFilter)
        .then(setTitleList)
        .then(setTopButtonList)
        .then(setSubTitle)
        .then(this.setCellType)
        .then(setThumbnailInfo)
        .then(this.clearCellList)
        .then(this.setCellList)
        .then(setPageCount)
        .then(scrollToTop)
        .then(loadComplete)
    },
    updateQuery () {
      this.setPagingQuery()
      this.setFilterQuery()
    },
    isAdultContentList () {
      return _.get(this.$route, 'query.adult', 'n').toLowerCase() === 'y'
    },
    setPagingQuery () {
      const pageNum = Number(_.get(this.$route, 'query.page', '1'))
      const { query } = parseUrl(decodeURIComponent(_.get(this.$route, 'query.api', '')))
      this.currentPage = +pageNum
      const pagingAppliedQuery = _.assign({}, query, { offset: (pageNum - 1) * this.limit })
      this.query = _.assign({}, this.query, pagingAppliedQuery)
    },
    setFilterQuery () {
      const urlQuery = _.get(this.$route, 'query', {})
      this.query = _.assign({}, this.query, urlQuery)
    },
    initialize () {
      const { url, query } = parseUrl(decodeURIComponent(_.get(this.$route, 'query.api', '')))
      this.url = url
      this.query = query
      this.updateQuery()
      if (this.isAdultContentList() && !getCheckAdult()) {
        doActionAdultVerification({ referer: getReferer(), enter: this.$route.fullPath })
      } else {
        this.setData()
      }
    },
    setCurrentMenu () {
      const menu = _.get(this.$route, ['query', 'came'], '')
      this[SET_CURRENT_MENU](menu)
    }
  },
  created () {
    setDisableScrolling(false)
    this.setCurrentMenu()
    this.initialize()
  },
  watch: {
    $route (newRoute, oldRoute) {
      const routeQuery = _.get(newRoute, 'query', {})
      this.updateQuery(routeQuery)
      this.initialize()
    }
  }
}
</script>
